export function phraseRowLayout() {
  return {
    row: "mt-2 flex flex-col gap-2 sm:flex-row",
    key: "w-full rounded bg-[#1F2937] px-3 py-2 sm:w-1/3",
    value: "w-full rounded bg-[#1F2937] px-3 py-2 sm:w-auto sm:min-w-0 sm:flex-1",
    remove: "px-3 sm:shrink-0",
  };
}
